module.exports = __webpack_public_path__ + "static/media/circle1.c4b04dce.png";